import * as $ from 'jquery';
import * as _ from 'lodash';

import { ModuleLayoutCollection } from '../../collections/ModuleLayout';
import { ModuleCollection } from '../../collections/Modules';
import { PriorityInstallDashboards } from '../../collections/PriorityDashboardInstalls';
import { SensorConfigCollection } from '../../collections/SensorConfigs';
import { SensorStatus } from '../../common/SensorStatus';
import { Utils } from '../../common/utils';
import { BaseInternalView } from '../_BaseViews';
import { ModifyDashboardModal } from '../modals/dashboard/ModifyDashboardModal';
import { SidePanelView } from './SidePanelView';
import { StatusChartView } from './StatusChartView';
import { SystemGraphView } from './SystemGraphView';

var template = require('templates/status/status.html');
var navigationLinks = require('templates/settings/navigationlinks.html');
navigationLinks = _.template(navigationLinks);
declare var App;

export class StatusView extends BaseInternalView {

    collection: ModuleCollection;
    moduleLayoutCollection: ModuleLayoutCollection;
    collectionLoaded: boolean = true;

    haveModules: boolean = false;

    protected moduleDotTemplate = _.template(require('templates/status/moduleLayoutStatusDot.html'))
    protected linkModuleTemplate = _.template(require('templates/settings/linkModuleTemplate.html'))

    private graphView: SystemGraphView = null;
    private sidePanelView: SidePanelView = null;
    private statusChartView: StatusChartView = null;
    private userCanViewSensorConfig: boolean;
    private currentInstallId: number = null;
    private currentModuleId: number = null;
    private currentOrgId: number = null;
    private currentFloor;
    private orderedFloors;
    private checkedView;
    private resetRequired: boolean = true;
    private refreshFrequency: number = 30;
    private collectionUpdateTimeouts: { [key: string]: any } = {};
    private sensorConfigCollection: SensorConfigCollection;
    private priorityInstallDashboards: PriorityInstallDashboards;

    private template = _.template(template);

    constructor(options) {
        super(<any>_.extend(options, {
            tagName: 'div',
            events: {
                'click .js-status-module-delete': 'handleDeleteModule',
                'click .js-status-sensor-delete-confirm': 'handleDeleteSensor',
                'change .status-select-module': 'handleModuleSelectChange',
                'click .previous-floor': 'handlePrevFloor',
                'click .next-floor': 'handleNextFloor',
                'change .show-layout-view': 'handleLayoutTypeView',
                'click .generate': 'handleGenerateDashboard',
                'click .hideUnavailableModules': 'handleHideUnavailableModules',
                'click .dragsvg': 'handleSidebarInteraction',
                'input #module-status-filter-input': 'moduleFilterChange'
            }
        }));

        this.collection = null;
        this.moduleLayoutCollection = null;

        $(window).off("resize");
        $(window).resize(() => {
            if (this.haveModules) this.redrawModules();
        });

    }

    private moduleFilterChange() {
        var modules = $('.dragsvg');
        var links = $('.module-line-connection');
        var filter = (<string>this.$('#module-status-filter-input').val()).toLowerCase();

        _.each(modules, (li) => {
            var number = $(li).data('module-number').toString();
            var location = $(li).data('module-location').toLowerCase();
            if ((location.indexOf(filter) !== -1 || number.indexOf(filter) !== -1)) {
                $(li).removeClass('hidden');
            } else {
                $(li).addClass('hidden');
            }
        });

        _.each(links, (link) => {
            var moduleLink1 = $('#svg-drag-module-' + (Number)($(link).data('moduleid1')));
            var number = moduleLink1.data('module-number').toString();
            var location = moduleLink1.data('module-location').toLowerCase();
            if ((location.indexOf(filter) !== -1 || number.indexOf(filter) !== -1)) {
                $(link).removeAttr('hidden');
            } else {
                $(link).attr('hidden', '');
            }
        })

    }

    setNavigationLinks() {
        this.$('nav').html(navigationLinks({
            permissionCollection: this.options.permissionCollection,
            installCollection: this.options.installCollection,
            currentCategory: 'status',
            currentOrgId: this.currentOrgId,
            currentInstallId: this.currentInstallId,
            currentModuleId: this.currentModuleId
        }));
    }

    private setNavPriorityIds() {
        const currentInstall = this.options.installCollection.findWhere({ id: this.currentInstallId });
        const priorityInstalls = [
            {
                name: currentInstall.get("organization_install_name"),
                id: currentInstall.get("id"),
                organizationName: currentInstall.get("organization_name"),
                organizationId: currentInstall.get("organization_id"),
            },
        ];
        window.dispatchEvent(new CustomEvent("priority:installs", { detail: priorityInstalls }));

        $.when(this.priorityInstallDashboards.getCollectionFetchPromise()).then(() => {
            const priorityDashboards = this.priorityInstallDashboards.map((dashboard) => {
                const organization = this.options.organizationCollection.findWhere({ id: dashboard.get('organization_id') });
                return {
                    id: dashboard.get('id') ,
                    name: dashboard.get('name'),
                    organizationName: organization.get('name'),
                    organizationId: organization.get('id'),
                }
            })
            window.dispatchEvent(new CustomEvent("priority:dashboards", { detail: priorityDashboards }));
        });
    }

    private handleLayoutTypeView(e) {
        var item = e.currentTarget;
        if (item.checked) {
            // $('#floor-title').text(this.currentFloor.get('name'));
            this.checkedView = true
            $('#status-svg-container').attr('hidden', '');
            $('#status-layout-container').removeAttr('hidden');
            // Hide module selector on layout view
            $('.status-select-module-container').addClass('hidden');

            this.renderModules(this.collectionLoaded, false);
        } else {
            this.checkedView = false;
            $('#status-svg-container').removeAttr('hidden');
            $('#status-svg-container').removeClass('hidden');
            $('#status-layout-container').attr('hidden', '');
            // Show module selector on default view
            $('.status-select-module-container').removeClass('hidden');
        }
    }

    private changeStartView() {
        this.checkedView = true
        $('#status-svg-container').attr('hidden', '');
        $('#status-layout-container').removeAttr('hidden');

        this.renderModules(this.collectionLoaded, false);
    }

    private handleHideUnavailableModules() {
        var hidden = $('.hideUnavailableModules').data('toggled')
        var modules = $('.dragsvg');
        var links = $('.module-line-connection');
        if (hidden) {
            _.each(modules, (item) => {
                $(item).removeAttr('hidden');
            })
            _.each(links, (link) => {
                $(link).removeAttr('hidden');
            })
            $('.hideUnavailableModules').addClass('fa-eye');
            $('.hideUnavailableModules').removeClass('fa-eye-slash');
            $('.hideUnavailableModules').data('toggled', false)
        } else {
            _.each(modules, (item) => {
                var itemCorrectFloor = $(item).data('available');
                var itemLayout = (Number)($(item).data('layout-id'));
                if ((itemLayout != this.currentFloor.get('id')) && itemCorrectFloor != 'true') {
                    $(item).attr('hidden', '');
                } else {
                    $(item).removeAttr('hidden');
                }
            })

            _.each(links, (link) => {
                var linkLayout = (Number)($(link).data('layout-id'));
                var moduleLink1 = $('#svg-drag-module-' + (Number)($(link).data('moduleid1')));
                var moduleLink2 = $('#svg-drag-module-' + (Number)($(link).data('moduleid2')));
                if (($(moduleLink1).data('layout-id') == this.currentFloor.get('id')) && ($(moduleLink2).data('layout-id') == this.currentFloor.get('id'))) {
                    // if (linkLayout == this.currentFloor.get('id')) {
                    $(link).removeAttr('hidden');
                } else {
                    $(link).attr('hidden', '');
                }
            })
            $('.hideUnavailableModules').removeClass('fa-eye');
            $('.hideUnavailableModules').addClass('fa-eye-slash');
            $('.hideUnavailableModules').data('toggled', true)
        }
    }

    private updateHiddenModules() {
        var hidden = $('.hideUnavailableModules').data('toggled')
        var modules = $('.dragsvg');
        var links = $('.module-line-connection');
        if (hidden) {
            _.each(modules, (item) => {
                var itemCorrectFloor = $(item).data('available');
                var itemLayout = (Number)($(item).data('layout-id'));
                if ((itemLayout != this.currentFloor.get('id')) && itemCorrectFloor != 'true') {
                    $(item).attr('hidden', '');
                } else {
                    $(item).removeAttr('hidden');
                }
            })

            _.each(links, (link) => {
                var linkLayout = (Number)($(link).data('layout-id'));
                var moduleLink1 = $('#svg-drag-module-' + (Number)($(link).data('moduleid1')));
                var moduleLink2 = $('#svg-drag-module-' + (Number)($(link).data('moduleid2')));
                if (($(moduleLink1).data('layout-id') == this.currentFloor.get('id')) && ($(moduleLink2).data('layout-id') == this.currentFloor.get('id'))) {
                    // if (linkLayout == this.currentFloor.get('id')) {
                    $(link).removeAttr('hidden');
                } else {
                    $(link).attr('hidden', '');
                }
            })
        }
    }

    private handleSidebarInteraction(e: JQuery.UIEventBase) {
        var node = e.currentTarget;
        var view = this;

        window.location.hash = '#/status/' + view.currentOrgId + '/' + view.collection.installId + '/' + $(node).data('module-id');
    }

    resetView() {
        if (this.collection) this.collection.stopListening();
        this.stopUpdating();
        this.removeSubViews();
        this.userCanViewSensorConfig = this.options.permissionCollection.canViewSensorConfig(this.currentInstallId);

        // Re-initialize
        this.collectionLoaded = false;
        this.collection = new ModuleCollection([], { installId: this.currentInstallId });
        this.moduleLayoutCollection = new ModuleLayoutCollection([], this.currentInstallId);
        this.priorityInstallDashboards = new PriorityInstallDashboards([], { installId: this.currentInstallId });
        $.when(this.collection.getCollectionFetchPromise({ reset: true }), this.moduleLayoutCollection.getCollectionFetchPromise({ reset: true }))
            .then(() => {
                this.perpetuallyUpdate(this.collection, 'module');
                this.collectionLoaded = true;
                var gateway = this.collection.getGateway();

                // Update Navbar
                this.setNavPriorityIds();

                // If this installation has no module, the following condition will be false
                if (gateway) {
                    if (this.currentModuleId) {
                        var currentModule = this.collection.findWhere({ module_id: this.currentModuleId });
                        if (currentModule.isVirtualModule()) {
                            window.location.hash = '/status/' + this.currentOrgId + '/' + this.currentInstallId + '/' + gateway.get('module_id');
                            this.currentModuleId = gateway.get('module_id');
                            return;
                        }
                    }

                    this.currentModuleId = !this.currentModuleId ? gateway.get('module_id') : this.currentModuleId;
                    this.sensorConfigCollection = new SensorConfigCollection([], { moduleId: this.currentModuleId });
                    if (this.userCanViewSensorConfig && this.currentModuleId) {
                        return this.sensorConfigCollection.fetch({ reset: true });
                    }
                }
                return $.Deferred().resolve();
            })
            .done(() => {
                window['App'].Bus.trigger('switch:install', this.currentInstallId, this.currentModuleId);
                this.render();

                // The status content renders here, after its data has loaded asynchronously,
                // so on navigation the page would otherwise keep the previous page's scroll
                // position (hash navigation doesn't reset it). Reset to the top now that the
                // content is in place, and again on the next frame after the graph finishes
                // its async layout.
                window.scrollTo(0, 0);
                window.requestAnimationFrame(() => window.scrollTo(0, 0));

                // Set up perpetual updates
                this.listenTo(this.collection, 'sync', this.renderSubViews.bind(this));
                this.listenTo(this.sensorConfigCollection, 'sync', this.renderSubViews.bind(this));
                //Don't bother fetching if user does not have permissions, or there is no gateway and thus nothing displays
                if (this.userCanViewSensorConfig && this.sensorConfigCollection && this.collection.getGateway()) {
                    this.perpetuallyUpdate(this.sensorConfigCollection, 'config');
                }
                this.resetRequired = false;
            });
        this.render();
    }

    resizeHandler() {
        var currentFloor = this.currentFloor;

        _.each(this.orderedFloors, (layout) => {
            $('#layout-svg-modules-container-' + layout.get('id')).remove('hidden');
            var coordinates = JSON.parse(layout.get('module_ui_positions'))
            var me = this;

            _.each(coordinates, (coordinate) => {
                var module = me.collection.findWhere({ module_id: Number(coordinate.id) });
                if (!module) return;
                var floorId = '#layout-svg-modules-container-' + layout.get('id');
                var resizeCoordinates = this.getScreenWidth(coordinate, floorId);

                $('#svg-drag-module-' + module.get('module_id')).css({
                    'width': resizeCoordinates.width,
                    'height': resizeCoordinates.height,
                    'left': resizeCoordinates.left,
                    'top': resizeCoordinates.top
                })
            })

            if (currentFloor.get('id') != layout.get('id')) {
                $('#layout-svg-modules-container-' + layout.get('id')).attr('hidden', '')
            }
        })
    }

    show(orgId, installId, moduleId) {
        if (orgId !== this.currentOrgId
            || installId !== this.currentInstallId) {

            this.resetRequired = true;
        }

        this.currentOrgId = orgId;
        this.currentInstallId = installId;
        this.currentModuleId = moduleId;

        if (this.resetRequired) {
            this.resetView();
        } else {
            this.renderSubViews();
            this.setNavigationLinks();
            this.perpetuallyUpdate(this.collection, 'module');
            this.userCanViewSensorConfig = this.options.permissionCollection.canViewSensorConfig(this.currentInstallId);
            if (this.userCanViewSensorConfig && this.sensorConfigCollection && this.collection.getGateway()) {
                this.perpetuallyUpdate(this.sensorConfigCollection, 'config');
            }
        }

        return this;
    }

    private handleModuleSelectChange(e: JQuery.UIEventBase) {
        const moduleId = Number($(e.currentTarget).val());

        // Fire click event on node to trigger seletion and focus
        // The click event is tied to an svg element
        // So it could not be fired by using regular methods like click() or trigger('click')
        // Using dispatchEvent seems to work
        const node = $(`.node-module-${moduleId}`)[0];
        node.dispatchEvent(new Event('click'));
    }

    handlePrevFloor() {
        var currentFloor = this.currentFloor;
        var paginated = false;
        _.each(this.orderedFloors.reverse(), function (layout) {
            if (currentFloor.get('order') > layout.get('order') && !paginated) {
                $('#layout-svg-modules-container-' + layout.get('id')).removeAttr('hidden')
                $('#layout-svg-modules-container-' + currentFloor.get('id')).attr('hidden', '')
                currentFloor = layout;
                $('#floor-title').text(currentFloor.get('name'));
                paginated = true;
            }
        })
        if (paginated) {
            this.currentFloor = currentFloor;
        }
        this.orderedFloors.reverse();
        this.disableModules();
        this.updateHiddenModules();
    }

    handleNextFloor() {
        var currentFloor = this.currentFloor;
        var paginated = false;
        _.each(this.orderedFloors, function (layout) {
            if (layout.get('order') > currentFloor.get('order') && !paginated) {
                $('#layout-svg-modules-container-' + layout.get('id')).removeAttr('hidden')
                $('#layout-svg-modules-container-' + currentFloor.get('id')).attr('hidden', '')
                currentFloor = layout;
                $('#floor-title').text(currentFloor.get('name'));
                paginated = true;
            }
        })
        this.currentFloor = currentFloor;
        this.disableModules();
        this.updateHiddenModules();
    }

    disableModules() {
        var modules = $('.dragsvg')
        var links = $('.module-line-connection');
        var tree = this.graphView.moduleConnections[1];

        _.each(modules, (item) => {
            var itemLayout = $(item).data('layout-id');
            if (itemLayout != this.currentFloor.get('id')) {
                $(item).addClass('disabled')
                $(item).data('available', 'false')
            } else {
                $(item).removeClass('disabled')
                $(item).data('available', 'true')
            }

            var dotId = '#' + $(item).attr('id');
            var dot = $(item).attr('data-module-id');
            if (+dot == this.currentModuleId) {
                $(dotId).css('box-shadow', ' 0px 0px 20px 5px ' + $(dotId).css('background-color'));
            } else {
                $(dotId).css('box-shadow', '');
            }

        })

        var gateway = this.collection.getGateway();
        _.each(links, (link) => {
            var moduleWithLink = null;
            var linkLayout = (Number)($(link).data('layout-id'));
            var moduleLink1 = $('#svg-drag-module-' + (Number)($(link).data('moduleid1')));
            var moduleLink2 = $('#svg-drag-module-' + (Number)($(link).data('moduleid2')));
            var moduleNumber1 = $(link).data('modulenumber1');
            var moduleNumber2 = $(link).data('modulenumber2');

            var flag = true;
            _.each(tree, (item) => {
                if (item[0] == moduleNumber1 && moduleNumber1 != gateway.get('module_number') && flag) {
                    moduleWithLink = moduleLink1;
                    flag = false;
                }
                //if (item[0] == moduleNumber2 && moduleNumber2 != gateway.get('module_number') && flag) {
                //    console.log("Module 2:" + moduleNumber2);
                //    moduleWithLink = moduleLink2;
                //    flag = false;
                //}
            })
            if (moduleWithLink) {
                if ($(moduleWithLink).data('layout-id') == this.currentFloor.get('id')) {
                    $(link).removeClass('module-line-connection-disabled');
                } else {
                    $(link).addClass('module-line-connection-disabled');
                }
            } else {
                $(link).addClass('module-line-connection-disabled');
            }
        })
    }


    renderModules(collectionLoaded, redraw) {
        if (!collectionLoaded) return;
        if (!redraw) this.currentFloor = this.orderedFloors[0];

        $('.svg-container').attr('hidden', '')
        $('.dragsvg').remove();
        $('.module-line-connection').remove();

        _.each(this.moduleLayoutCollection.models, (layout) => {
            var coordinates = JSON.parse(layout.get('module_ui_positions'))
            var sensorConfigCollection;
            var moduleStatus;
            var me = this;
            var floorId = '#layout-svg-modules-container-' + layout.get('id');
            $(floorId).removeAttr('hidden')

            _.each(coordinates, (coordinate) => {
                var module = me.collection.findWhere({ module_id: Number(coordinate.id) });
                if (!module) return;
                var imageId = '#img-modules-container-' + layout.get('id');
                var colorStatus = '';
                var lastSeen = module.getConnectorLastSeenText(0);
                var linkQuality = module.getLinkQuality();

                if (!linkQuality) linkQuality = '-';
                var sensorStatus = new SensorStatus({
                    sensorConfigCollection: sensorConfigCollection,
                    moduleModel: module
                });
                moduleStatus = sensorStatus.getCombinedStatus(null, 0);

                switch (moduleStatus.status) {
                    case 'danger':
                        colorStatus = '#D61F26'
                        break;
                    case 'warning':
                        colorStatus = '#FFC04F'
                        break;
                    default:
                        colorStatus = '#4CB975'
                        break;
                }
                var resizeCoordinates = this.getScreenWidth(coordinate, imageId);

                $('#layout-svg-container').append(this.moduleDotTemplate({
                    module: module,
                    lastSeen: lastSeen,
                    linkQuality: linkQuality,
                    moduleStatus: moduleStatus,
                    layout: layout,
                    resizeCoordinates: resizeCoordinates,
                    colorStatus: colorStatus
                }))

                //}

            })

            $(floorId).attr('hidden', '')
        })
        this.drawModulesConnections(this.graphView.moduleConnections);
        if (this.currentFloor) {
            if (!redraw) {
                $('.floor').first().removeAttr('hidden');
                $('#floor-title').text(this.currentFloor.get('name'));
            } else {
                $('#layout-svg-modules-container-' + this.currentFloor.get('id')).removeAttr('hidden')
                $('#floor-title').text(this.currentFloor.get('name'));
            }
        }

        this.disableModules();
    }

    drawModulesConnections(dataStructure) {
        this.graphView.switchNode();
        var modules = $('.dragsvg');
        var availableModules = [];
        var tree = dataStructure[0];
        var edges = dataStructure[1];
        var linkModuleTemplate = this.linkModuleTemplate
        function line(x, y, x1, y1, link, item, mod) {
            var linkStyle;
            var offset;
            if (link <= 100 && link >= 75) { linkStyle = 'high-connection'; offset = '5'; }
            else if (link < 75 && link >= 50) { linkStyle = 'midh-connection'; offset = '4'; }
            else if (link < 50 && link >= 30) { linkStyle = 'midl-connection'; offset = '3'; }
            else { linkStyle = 'low-connection'; offset = '3'; }
            var w = 5;
            var transform = Math.atan2((y1 - y), (x1 - x))
            var intensityNumberTransform = transform * -1;
            var css = {
                top: y + w + 5,
                left: x + w + 5,
                opacity: 1,
                width: Math.sqrt((x1 - x) * (x1 - x) + (y1 - y) * (y1 - y)),
                transform: 'rotate(' + transform + 'rad)'
            };

            $('#layout-svg-container').append(linkModuleTemplate({
                css: css,
                moduleId1: $(mod).data('moduleId'),
                moduleId2: $(item).data('moduleId'),
                moduleNumber1: $(mod).data('moduleNumber'),
                moduleNumber2: $(item).data('moduleNumber'),
                linkIntesity: link,
                linkStyle: linkStyle,
                offset: offset,
                layoutId: $(mod).data('layoutId'),
                intensityNumberTransform: intensityNumberTransform
            }));
        }

        function searchByNumber(moduleNumber) {
            var item;
            _.each(modules, (mod) => {
                if ($(mod).data('module-number') == moduleNumber) {
                    item = mod;
                }
            })
            return item;
        }

        _.each(modules, (mod) => {
            _.each(tree, (item) => {
                if (($(mod).data('module-id') == item.id) && (item.depends != '')) {
                    // availableModules.push(mod);

                    var objItem = $(searchByNumber((Number)(item.depends)))
                    var pos1 = objItem.position()
                    var pos0 = $(mod).position()
                    if (pos1 && pos0) {
                        var x0 = pos0.left,
                            y0 = pos0.top,
                            x1 = pos1.left,
                            y1 = pos1.top;
                        line(x0, y0, x1, y1, item.link, objItem, mod);
                    }
                }
            })
        })
        //console.log(availableModules)
        this.moduleFilterChange();

    }

    getScreenWidth(coordinate, container) {
        var containerH = ($(container).height() * coordinate.y) / coordinate.heightImg;
        var containerW = ($(container).width() * coordinate.x) / coordinate.widthImg;
        // var moduleH = ($(container).height() * 20) / coordinate.heightImg;
        // var moduleW = ($(container).width() * 20) / coordinate.widthImg;
        var moduleH = 20
        var moduleW = 20
        //WIP: CHECK STATUS TEMPLATE  + 60
        return { left: containerW, top: containerH + 40, width: moduleW, height: moduleH };
    }

    stopUpdating() {
        _.each(this.collectionUpdateTimeouts, (t) => {
            clearTimeout(t);
        });
    }

    perpetuallyUpdate(collection, key) {
        // Check if there is an existing timeout for the same key and clear it.
        if (this.collectionUpdateTimeouts[key]) {
            clearTimeout(this.collectionUpdateTimeouts[key]);
        }

        if (key === 'config') {
            var gateway = this.collection.getGateway();
            this.currentModuleId = !this.currentModuleId ? gateway.get('module_id') : this.currentModuleId;
            collection.moduleId = this.currentModuleId;
        }
        $.when((<any>collection).fetch({ timeout: this.refreshFrequency * 500 }))
            .done(() => {
                this.collectionUpdateTimeouts[key] = setTimeout(
                    _.bind(this.perpetuallyUpdate, this), this.refreshFrequency * 1000, collection, key);
            })
            .fail(() => {
                // Back off a little bit if something goes wrong as to not additionally stress the server
                this.collectionUpdateTimeouts[key] = setTimeout(
                    _.bind(this.perpetuallyUpdate, this), 3 * this.refreshFrequency * 1000, collection, key);
            });
    }

    hideChart() {
        if (this.checkedView) {
            // $('#floor-title').text(this.currentFloor.get('name'));
            $('#status-layout-container').removeAttr('hidden');
        } else {
            $('#status-svg-container').removeAttr('hidden');
            $('#status-svg-container').removeClass('hidden');
        }
        this.$('#status-chart-container').addClass('hidden');

        if (this.statusChartView) {
            this.sidePanelView.collapseAllSensors();
            this.statusChartView.remove();
            this.statusChartView = null;
        }
        this.redrawModules();
    }

    showChart(connector, channels) {
        $('#status-layout-container').attr('hidden', '');
        this.$('#status-svg-container').addClass('hidden');
        this.$('#status-chart-container').removeClass('hidden');

        if (!this.statusChartView) {
            this.statusChartView = new StatusChartView({
                model: this.getCurrentModel(),
                permissionCollection: this.options.permissionCollection,
                parentView: this,
                currentUser: this.options.currentUser
            });
            this.$('#status-chart-container').append(this.statusChartView.render().$el);
        }
        this.statusChartView.showChart(connector, channels);
    }

    getCurrentModel() {
        return !this.collection || !this.currentModuleId ? null : this.collection.findWhere({
            'module_id': this.currentModuleId
        });
    }

    removeModules() {
        $('.dragsvg').remove();
        $('.module-line-connection').remove();
    }

    redrawModules() {
        this.removeModules();
        this.renderModules(this.collectionLoaded, true);
        this.updateHiddenModules();
        // this.handleHideUnavailableModules();
    }

    render() {
        var install = this.options.installCollection.findWhere({
            id: this.currentInstallId,
            organization_id: this.currentOrgId ? this.currentOrgId : null
        });

        var installName = '';
        if (install) {
            installName = install.get('organization_install_name');
            if (!installName) installName = install.get('name');
        }

        var layouts = this.moduleLayoutCollection.where({ install_id: this.currentInstallId });
        layouts.sort((a, b) => (a.attributes.order ?? Infinity) - (b.attributes.order ?? Infinity));
        this.currentFloor = layouts[0];
        this.orderedFloors = layouts;
        this.haveModules = false;

        _.each(layouts, (layout) => {
            if (layout.get('module_ui_positions') != '[]') {
                this.haveModules = true;
            }
        })

        this.$el.html(this.template({
            collectionLoaded: this.collectionLoaded,
            installName: installName,
            moduleModel: this.getCurrentModel(),
            currentOrgId: this.currentOrgId,
            currentInstallId: this.currentInstallId,
            currentModuleId: this.currentModuleId,
            currentUser: this.options.currentUser,
            layoutCollection: layouts,
            haveModules: this.haveModules,
            moduleCollection: this.collection.models.length > 0 ? this.collection.models : null
        }));

        this.renderSubViews();
        this.setNavigationLinks();
        if (this.haveModules) this.changeStartView();
        // this.renderModules(this.collectionLoaded);

        (<any>this.$('[data-toggle="toggle"]')).bootstrapToggle();
        this.$('select').select2(Utils.Select2.defaultOptions);

        return this;
    }

    renderSubViews() {
        if (!this.collectionLoaded) return;
        var currentModel = this.getCurrentModel();
        if (!currentModel) {
            return;
        }

        if (this.sensorConfigCollection.moduleId !== currentModel.id) {
            if (this.userCanViewSensorConfig) {
                this.sensorConfigCollection.moduleId = Number(currentModel.id);
                $.when(this.sensorConfigCollection.fetch({ reset: true }))
                    .done(() => {
                        var currentModel = this.getCurrentModel();
                        if (this.sidePanelView) {
                            this.sidePanelView.setModel(currentModel)
                        }
                    });
            }
        }

        // Side Panel
        if (!this.sidePanelView) {
            this.sidePanelView = new SidePanelView(_.extend({}, this.options, {
                model: currentModel,
                collection: this.collection,
                currentInstallId: this.currentInstallId,
                currentOrgId: this.currentOrgId,
                permissionCollection: this.options.permissionCollection,
                parentView: this,
                sensorConfigCollection: this.sensorConfigCollection
            }));
            this.sidePanelView.render()
        } else {
            if (this.sidePanelView.model !== currentModel) {
                this.sidePanelView.setModel(currentModel);
            } else {
                this.sidePanelView.render();
            }
        }

        // System Graph
        if (!this.graphView) {
            this.graphView = new SystemGraphView({
                collection: this.collection,
                initialModuleId: this.currentModuleId,
                orgId: this.currentOrgId,
                sensorConfigCollection: this.sensorConfigCollection,
                moduleLayoutCollection: this.moduleLayoutCollection
            });
        } else if (this.resetRequired) {
            this.graphView.show({
                collection: this.collection,
                initialModuleId: this.currentModuleId,
                orgId: this.currentOrgId,
                sensorConfigCollection: this.sensorConfigCollection,
                moduleLayoutCollection: this.moduleLayoutCollection

            });
        } else {
            this.graphView.render();
        }

        if (this.statusChartView) {
            this.statusChartView.updateDashboardChannels()
        }
        this.haveModules ? this.redrawModules() : this.graphView.switchNode();

    }

    handleGenerateDashboard() {
        var modal = new ModifyDashboardModal({
            appRegistry: this.options.appRegistry,
            appCollection: this.options.appCollection,
            brandCollection: this.options.brandCollection,
            installCollection: this.options.installCollection,
            dashboardCollection: this.options.dashboardCollection,
            permissionCollection: this.options.permissionCollection,
            organizationCollection: this.options.organizationCollection,
            dashboardChannelCollection: this.options.dashboardChannelCollection,
            currentUser: this.options.currentUser,
            generate: true,
            installId: this.currentInstallId,
            modelId: null
        });
        $('.modals').append(modal.render().el);
        modal.show();
    }

    private removeSubViews() {
        if (this.graphView) this.graphView.remove();
        if (this.statusChartView) this.statusChartView.remove();
        if (this.sidePanelView) this.sidePanelView.remove();

        this.graphView = null;
        this.statusChartView = null;
        this.sidePanelView = null;
    }

    remove() {
        this.stopUpdating();
        this.removeSubViews();
        return super.remove();
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/views/status/StatusView.ts